import { apiGet, apiPost } from './client';

export interface MemberMessageItem {
  id: string;
  messageId: string;
  companyCode: string;
  recipientCustomerId: string;
  subject: string;
  content: string;
  category: string;
  subcategory: string;
  status: string;
  isRead: boolean;
  createdAtUtc: string;
  readAtUtc: string | null;
}

export interface MemberMessageSearchResult {
  companyCode: string;
  page: number;
  pageSize: number;
  total: number;
  items: MemberMessageItem[];
}

export interface MemberMessageSearchParams {
  recipientCustomerId: string;
  page?: number;
  pageSize?: number;
  status?: 'all' | 'unread' | 'read';
  category?: string;
}

export interface CreateMemberMessageRequest {
  recipientCustomerId: string;
  requestId: string;
  subject: string;
  content: string;
  category: string;
  subcategory?: string;
}

export interface CreateMemberMessageResult {
  id: string;
  messageId: string;
  companyCode: string;
  recipientCustomerId: string;
  status: string;
  createdAtUtc: string;
  created: boolean;
}

export async function searchMemberMessages(
  params: MemberMessageSearchParams
): Promise<MemberMessageSearchResult> {
  const response = await apiGet<MemberMessageSearchResult>('/member-messages', params);
  if (!response.data) {
    throw new Error(response.message || 'Failed to search member messages.');
  }
  return response.data;
}

export async function createMemberMessage(
  request: CreateMemberMessageRequest
): Promise<CreateMemberMessageResult> {
  const response = await apiPost<CreateMemberMessageResult>('/member-messages', request);
  if (!response.data) {
    throw new Error(response.message || 'Failed to create member message.');
  }
  return response.data;
}
